import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { isEqual } from 'lodash'
import WaitAction from 'wait/WaitAction'
import MaterielAction from '../../../../../materiel/actions/MaterielAction'
import AntennaAction from '../../../../../materiel/components/antenna/actions/AntennaAction'
import AntennaPanel from '../../../../../materiel/components/antenna/components/AntennaPanel'
import SituationDetailPanel from '../SituationDetailPanel'
import DtoStation from '../../../../dto/DtoStation'
import { getStationTypeCodeFromType } from '../../../../../utils/StationUtils'
import { Card, CardContent } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue } from 'utils/constants/ColorTheme'

const AntennaSituationDetail = ({ params, type, station }) => {
    const [antenna, setAntenna] = useState({})
    const [antennaDefaultParam, setAntennaDefaultParam] = useState({})

    const materielStates = useSelector(store => store.MaterielReducer.materielStates)
    const antennas = useSelector(store => store.AntennaReducer.antennas)
    const antennasLastSituations = useSelector(store => store.AntennaReducer.antennasLastSituations)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!materielStates.length) {
            dispatch(MaterielAction.fetchMaterielStates())
        }
        if (!antennas.length) {
            dispatch(AntennaAction.fetchAntennas())
        }
        if (!antennasLastSituations.length) {
            dispatch(AntennaAction.fetchAntennasLastSituations())
        }
    }, [])

    const getAntennaTitle = ({ serialNumber, code, name }) => {
        const reference = serialNumber || code || ''
        return name ? `${name} - ${reference}` : reference || i18n.unknownMaterial
    }

    const getAntennaPanel = isEditMode => {
        if (antenna.id) {
            return (
                <Card>
                    <CardTitle title={getAntennaTitle(antenna)} color={darkBlue}/>
                    <CardContent>
                        <AntennaPanel
                            antenna={antenna}
                            onChange={changes => setAntenna(prev => ({ ...prev, ...changes }))}
                            disabled={!isEditMode}
                        />
                    </CardContent>
                </Card>
            )
        }
        return null
    }

    const fetchAntenna = id => {
        dispatch(WaitAction.waitStart())
        dispatch(AntennaAction.fetchAntenna(id)).then(json => {
            setAntenna(json)
            setAntennaDefaultParam(json)
            dispatch(WaitAction.waitStop())
        })
    }

    const updateAntenna = () => {
        if (!isEqual(antenna, antennaDefaultParam)) {
            dispatch(AntennaAction.updateAntenna(antenna))
        }
    }

    const resetAntenna = () => {
        dispatch(AntennaAction.resetAntenna())
        setAntenna({})
        setAntennaDefaultParam({})
    }

    const addAntennaSituation = situation => dispatch(AntennaAction.saveAntennaSituation(situation))

    const saveAntennaSituation = situation => dispatch(AntennaAction.updateAntennaSituation(situation))

    const deleteAntennaSituation = situation => dispatch(AntennaAction.deleteAntennaSituation(situation.id, situation.idAntenne))

    const siteType = getStationTypeCodeFromType(type)
    const siteCode = parseInt(params.id)
    const stationAntennaAssignments = antennasLastSituations.filter(s => s.siteType === siteType && s.siteCode === siteCode)

    return (
        <SituationDetailPanel
            params={params}
            type={type}
            getMaterielPanel={isEditMode => getAntennaPanel(isEditMode)}
            station={station}
            materiels={antennas}
            lastSituations={antennasLastSituations}
            materielTypes={[]}
            stationMaterielAssignments={stationAntennaAssignments}
            addSituation={addAntennaSituation}
            saveSituation={saveAntennaSituation}
            deleteSituation={deleteAntennaSituation}
            fetchMateriel={fetchAntenna}
            updateMateriel={updateAntenna}
            resetMateriel={resetAntenna}
            keyMaterielType='antenneType'
            keyMaterielId='idAntenne'
        />
    )
}

AntennaSituationDetail.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
        materialType: PropTypes.string,
    }),
    type: PropTypes.string,
    station: PropTypes.instanceOf(DtoStation),
}

export default AntennaSituationDetail